import { Button, Card, Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionRuntimeConfigs } from '../shared/SectionRuntimeConfigs';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';

const LOTTERY_CFG_FILTER = (k: string) =>
  /^(lottery_|draw_address)/i.test(k) || /lottery_ticket_vol_|lottery_tickets_per_box_open/i.test(k);

export default function BlindBoxHolidayLotteryConfigList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-holiday-lottery-config" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.holidayLotteryConfig')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.holidayLotteryConfig') },
          ]}
          action={
            <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>
              {t('module.blindBox.refreshAll')}
            </Button>
          }
        />
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <SectionRuntimeConfigs refreshKey={refreshKey} keyFilter={LOTTERY_CFG_FILTER} />
          </Card>
        </Stack>
      </DashboardContent>
    </PermissionGuard>
  );
}

